export function measures(state) {
  return state.measures
}

export function cycleTypes(state) {
  return state.cycleTypes
}

export function cycleSegments(state) {
  return state.cycleSegments
}

export function cycleBeads(state) {
  return state.cycleBeads
}
